const cardsResources = {
  en: {
    translation: {
      CardsTitle: 'Insurance programs',
      'Cards1 title': 'Motor insurance',
      'Cards1 price': 'from 2,438 ₸',
      'Cards1 subtitle1': 'Insurance in 3 minutes',
      'Cards1 description1': 'Online application',
      'Cards1 subtitle2': 'Participation in competitions',
      'Cards1 description2': 'Every week',
      'Cards1 subtitle3': '24/7 Consultation ',
      'Cards1 description3': 'In case of Insured Event',
      'Cards1 subtitle4': 'Discounts of 50% for preferential categories',
      'Cards1 description4':
        'Persons with disabilities, pensioners and veterans of the Second World War',
      'Cards2 title': 'Travel',
      'Cards2 price': 'from 750 ₸',
      'Cards2 subtitle1': 'Territory of your choice',
      'Cards2 description1': 'World countries, Schengen, Whole World',
      'Cards2 subtitle2': 'Medicine',
      'Cards2 description2': 'Large range of medical services + dentistry',
      'Cards2 subtitle3': 'Covid-19',
      'Cards2 description3': 'Protection from Covid-19',
      'Cards2 subtitle4': 'Insurance',
      'Cards2 description4': '24/7 insurance',
      'Cards3 title': 'Health',
      'Cards3 price': 'from 1,000 ₸',
      'Cards3 subtitle1': 'Sum insured from 500 000 tenge',
      'Cards3 description1': 'up to 5 000 000 KZT',
      'Cards3 subtitle2': 'Choice of territory',
      'Cards3 description2': 'RK, CIS, World',
      'Cards3 subtitle3': 'Protection 24 hours',
      'Cards3 description3': 'Protection effective 24 hours a day',
      'Cards3 subtitle4': 'Age',
      'Cards3 description4': 'Age 1 to 65 ',
      'Cards4 title': 'Property insurance',
      'Cards4 price': 'from 1,125 ₸',
      'Cards4 subtitle1': 'Property insurance',
      'Cards4 description1': 'Value up to 100 million tenge',
      'Cards4 subtitle2': 'Limit',
      'Cards4 description2': 'Up to 30 % limit of insurance',
      'Cards4 subtitle3': 'Term',
      'Cards4 description3': 'Term of insurance from 6 to 12 months',
      'Cards4 subtitle4': 'Risk package',
      'Cards4 description4': 'Full risk package',
      'Cards button': 'Apply for insurance',
    },
  },
  kz: {
    translation: {
      CardsTitle: 'Сақтандыру бағдарламалары',
      'Cards1 title': 'Автосақтандыру',
      'Cards1 price': '2 438 ₸ бастап',
      'Cards1 subtitle1': '3 минуттың ішінде ресімдеңіз',
      'Cards1 description1': 'Онлайн рәсім',
      'Cards1 subtitle2': 'Конкурстарға қатысу',
      'Cards1 description2': 'Әр аптада',
      'Cards1 subtitle3': 'Тәулік бойғы консультация',
      'Cards1 description3': 'Сақтандыру жағдайында',
      'Cards1 subtitle4': 'Жеңілдік санаты үшін 50%  жеңілдіктер',
      'Cards1 description4': 'Мүгедектер, зейнеткерлер және ҰОС ардагерлері',
      'Cards2 title': 'Саяхаттар',
      'Cards2 price': '750 ₸ бастап',
      'Cards2 subtitle1': 'Аумақты таңдаңыз',
      'Cards2 description1': 'Әлем елдері, Шенген, Бүкіл әлем',
      'Cards2 subtitle2': 'Медицина',
      'Cards2 description2': 'Медициналық қызметтердің кең аясы + тіс емханасы',
      'Cards2 subtitle3': 'Covid-19',
      'Cards2 description3': 'Сovid-19-дан қорғау',
      'Cards2 subtitle4': 'Сақтандыру',
      'Cards2 description4': '24/7 сақтандыру',
      'Cards3 title': 'Денсаулық',
      'Cards3 price': '1 000 ₸ бастап',
      'Cards3 subtitle1': 'Сақтандыру сомасы 500 000 теңгеден ',
      'Cards3 description1': '5 000 000 теңгеге дейін',
      'Cards3 subtitle2': 'Аумақты таңдаңыз',
      'Cards3 description2': 'ҚР, ТМД елдері, Бүкіл әлем',
      'Cards3 subtitle3': '24 сағат қорғау',
      'Cards3 description3': 'Қорғау тәулігіне 24 сағат әрекет етеді',
      'Cards3 subtitle4': 'Жасы',
      'Cards3 description4': '1 жастан 65 жасқа дейін',
      'Cards4 title': 'Мүлікті сақтандыру',
      'Cards4 price': '1 125 ₸ бастап',
      'Cards4 subtitle1': 'Мүлікті сақтандыру',
      'Cards4 description1': 'Қүны 100 млн. теңгеге дейін',
      'Cards4 subtitle2': 'Лимит',
      'Cards4 description2':
        'Әрлеуді сақтандыру лимиті сақтандыру сомасының 30% дейін',
      'Cards4 subtitle3': 'Мерзімі',
      'Cards4 description3': 'Сақтандыру мерзімі 6-дан 12 айға дейін',
      'Cards4 subtitle4': 'Тәуекелдер топтамасы',
      'Cards4 description4': 'Тәуекелдердің толық топтамасы',
      'Cards button': 'Ресімдеңіз',
    },
  },
  ru: {
    translation: {
      CardsTitle: 'Программы страхования',
      'Cards1 title': 'Автострахование',
      'Cards1 price': 'от 2 438 ₸',
      'Cards1 subtitle1': 'Оформление за 3 минуты',
      'Cards1 description1': 'Онлайн процедура',
      'Cards1 subtitle2': 'Участие в конкурсах',
      'Cards1 description2': 'Каждую неделю',
      'Cards1 subtitle3': 'Круглосуточная консультация',
      'Cards1 description3': 'При страховом случае',
      'Cards1 subtitle4': 'Скидки 50% для льготной категории',
      'Cards1 description4': 'Инвалиды, пенсионеры и ветераны ВОВ',
      'Cards2 title': 'Путешествия',
      'Cards2 price': 'от 750 ₸',
      'Cards2 subtitle1': 'Территория на выбор',
      'Cards2 description1': 'Страны мира, Шенген, Весь мир',
      'Cards2 subtitle2': 'Медицина',
      'Cards2 description2': 'Широкий спектр медицинских услуг + стоматология',
      'Cards2 subtitle3': 'Covid-19',
      'Cards2 description3': 'Защита от covid-19',
      'Cards2 subtitle4': 'Страховка',
      'Cards2 description4': 'Страховка 24/7',
      'Cards3 title': 'Здоровье',
      'Cards3 price': 'от 1 000 ₸',
      'Cards3 subtitle1': 'Страховая сумма от 500 000 тенге',
      'Cards3 description1': 'до 5 000 000 тенге',
      'Cards3 subtitle2': 'Территория на выбор',
      'Cards3 description2': 'РК, Страны СНГ, Весь мир',
      'Cards3 subtitle3': 'Защита 24 часа',
      'Cards3 description3': 'Защита действует 24 часа в сутки',
      'Cards3 subtitle4': 'Возраст',
      'Cards3 description4': 'Возраст от 1 года до 65 лет',
      'Cards4 title': 'Страхование имущества',
      'Cards4 price': 'от 1 125 ₸',
      'Cards4 subtitle1': 'Страхование имущества',
      'Cards4 description1': 'Стоимостью до 100 млн. тенге',
      'Cards4 subtitle2': 'Лимит',
      'Cards4 description2':
        'Лимит на страхование отделки до 30% от страховой суммы',
      'Cards4 subtitle3': 'Срок',
      'Cards4 description3': 'Срок страхования от 6 до 12 месяцев',
      'Cards4 subtitle4': 'Пакет рисков',
      'Cards4 description4': 'Полный пакет рисков',
      'Cards button': 'Оформить',
    },
  },
};

export default cardsResources;
